export const emailRegExp = new RegExp(/^[a-zA-Z_0-9-'\+~]+(\.[a-zA-Z_0-9-'\+~]+)*@([a-zA-Z_0-9-]+\.)+[a-zA-Z]{2,7}$/);
export const VALID_EMAIL_DOMAIN = "grainger.com";
export const validEmailDomainRegExp = new RegExp(/^.*@grainger\.com$/i);
